import React, { useState } from "react";
import {
  DatePicker,
  Divider,
  Form,
  Input,
  Button,
  TimePicker,
  Modal
} from "antd";
import "./LicenseInfo.css";

export const LicenseInfo = ({ form, companyInfo }) => {
  const { getFieldDecorator } = form;
  const { tariffTypeId, tariffTypeKey } = companyInfo;
  const maxVehicleNum = (tariffTypeId && tariffTypeId.maxVehicleNum) || "",
    maxDriverNum = (tariffTypeId && tariffTypeId.maxDriverNum) || "",
    maxWorkplaceNum = (tariffTypeId && tariffTypeId.maxWorkplaceNum) || "",
    maxPerformerNum = (tariffTypeId && tariffTypeId.maxPerformerNum) || "",
    tariffType = (tariffTypeId && tariffTypeId.tariffType) || "";
  const monthFee = tariffTypeId && tariffTypeId.tariffPrices[0].tariffPrice;

  const DateFormat = "DD.MM.YYYY";
  const TimeFormat = "HH:MM";

  let [visible, setVisible] = useState(false);

  // Для будущего отображения дополнительных услуг
  // const additionalServices = companyInfo.tariffTypeId.additionalServices.map(item => {
  //     return ({
  //         price: item.additionalServiceId.additionalServicePrice,
  //         key: item.additionalServiceId.additionalServiceKey,
  //         text: item.additionalServiceId.additionalService,
  //         id: item.additionalServiceId.additionalServiceId
  //     })
  // })
  const openTariffInfo = () => {
    setVisible(true);
  };

  const closeTariffInfo = () => {
    setVisible(false);
  };

  return (
    <>
      <Modal
        visible={visible}
        centered={true}
        width={752}
        onCancel={closeTariffInfo}
        title={"Тариф «" + tariffType + "»"}
        footer={[
          <Button
            key="close"
            style={{ width: "176px" }}
            type="primary"
            onClick={closeTariffInfo}
          >
            Закрыть
          </Button>
        ]}
        className={"license-info"}
      >
        <div className={"license-info__price price"}>
          <h2 className={"price__fee"}>{monthFee} руб.</h2>
          <span className={"price__period"}>в месяц</span>
        </div>
        <div className={"license-info__features features"}>
          <p className={"features__item"}>
            до <span className={"features__bold"}>{maxVehicleNum} ТС</span>
          </p>
          <p className={"features__item"}>
            до <span className={"features__bold"}>{maxDriverNum}</span>{" "}
            {maxDriverNum
              .toString()
              .charAt(maxDriverNum.toString().length - 1) === "1" &&
            maxDriverNum !== 11
              ? "водителя"
              : "водителей"}
          </p>
          <p className={"features__item"}>
            <span className={"features__bold"}>{maxWorkplaceNum}</span>{" "}
            {maxWorkplaceNum
              .toString()
              .charAt(maxWorkplaceNum.toString().length - 1) === "1" &&
            maxWorkplaceNum !== 11
              ? "рабочее место"
              : "рабочих мест"}
          </p>
          <p className={"features__item"}>
            <span className={"features__bold"}>{maxPerformerNum}</span>{" "}
            {(maxPerformerNum
              .toString()
              .charAt(maxPerformerNum.toString().length - 1) === "2" &&
              maxPerformerNum !== 12) ||
            (maxPerformerNum
              .toString()
              .charAt(maxPerformerNum.toString().length - 1) === "3" &&
              maxPerformerNum !== 13) ||
            (maxPerformerNum
              .toString()
              .charAt(maxPerformerNum.toString().length - 1) === "4" &&
              maxPerformerNum !== 14)
              ? "исполнителя"
              : maxPerformerNum
                  .toString()
                  .charAt(maxPerformerNum.toString().length - 1) === "1" &&
                maxPerformerNum !== 11
              ? "исполнитель"
              : "исполнителей"}
          </p>
        </div>
        {tariffTypeKey !== "starter" ? (
          <div className={"license-info__text"}>
            <p>
              В тариф также входят следующие модули:
              <br />- Автоматическое форматирование документов перевозки
              (договор услуги, заказ-наряд, путевой лист и т.д.);
            </p>
            <p>
              Также доступны
              <span className={"text-strong"}>дополнительные услуги</span>:
              <br />- Каждый водитель сверх лимита:
              <span className={"text-strong"}>100</span> руб./месяц;
              <br />- Каждое ТС сверх лимита (более 400 ТС):
              <span className={"text-strong"}>2500</span> руб./месяц;
              <br />- Каждый дополнительный исполнитель:
              <span className={"text-strong"}>2500</span> руб./месяц (максимум -
              2 исполнителя);
            </p>
          </div>
        ) : tariffTypeKey === "standart" ? (
          <div className={"license-info__text"}>
            <p>
              В тариф также входят следующие модули:
              <br />- Автоматическое форматирование документов перевозки
              (договор услуги, заказ-наряд, путевой лист и т.д.);
            </p>
            <p>
              Также доступны
              <span className={"text-strong"}>дополнительные услуги</span>:
              <br />- Каждый водитель сверх лимита:
              <span className={"text-strong"}>100</span> руб./месяц;
              <br />- Каждое рабочее место сверх лимита:
              <span className={"text-strong"}>500</span> руб./месяц;
              <br />- Каждое ТС сверх лимита (более 400 ТС):
              <span className={"text-strong"}>2500</span> руб./месяц;
              <br />- Каждый дополнительный исполнитель:
              <span className={"text-strong"}>2500</span> руб./месяц (максимум -
              4 исполнителя);
            </p>
          </div>
        ) : tariffTypeKey === "advanced" ? (
          <div className={"license-info__text"}>
            <p>
              В тариф также входят следующие модули:
              <br />- Автоматическое форматирование документов перевозки
              (договор услуги, заказ-наряд, путевой лист и т.д.);
            </p>
            <p>
              Также доступны
              <span className={"text-strong"}>дополнительные услуги</span>:
              <br />- Каждый водитель сверх лимита:
              <span className={"text-strong"}>100</span> руб./месяц;
              <br />- Каждое рабочее место сверх лимита:
              <span className={"text-strong"}>500</span> руб./месяц;
              <br />- Каждое ТС сверх лимита (более 400 ТС):
              <span className={"text-strong"}>2500</span> руб./месяц;
              <br />- Каждый дополнительный исполнитель:
              <span className={"text-strong"}>2500</span> руб./месяц (максимум -
              4 исполнителя);
            </p>
          </div>
        ) : tariffTypeKey === "maximum" ? (
          <div className={"license-info__text"}>
            <p>
              В тариф также входят следующие модули:
              <br />- Автоматическое форматирование документов перевозки
              (договор услуги, заказ-наряд, путевой лист и т.д.);
            </p>
            <p>
              Также доступны
              <span className={"text-strong"}>дополнительные услуги</span>:
              <br />- Каждый водитель сверх лимита:
              <span className={"text-strong"}>100</span> руб./месяц;
              <br />- Каждое рабочее место сверх лимита:
              <span className={"text-strong"}>500</span> руб./месяц;
              <br />- Каждое ТС сверх лимита (более 400 ТС):
              <span className={"text-strong"}>2500</span> руб./месяц;
              <br />- Каждый дополнительный исполнитель:
              <span className={"text-strong"}>2500</span> руб./месяц (максимум -
              8 исполнителя);
            </p>
          </div>
        ) : null}
      </Modal>
      <div className="offer-card__item">
        <span className="label">Номер лицензии:</span>

        <Form.Item>
          {getFieldDecorator("licenseNumber")(
            <Input disabled style={{ width: 368 }} />
          )}
        </Form.Item>
      </div>
      <div className="offer-card__item">
        <span className="label">Дата создания:</span>
        {getFieldDecorator("createdAtDate")(
          <DatePicker
            style={{ width: 224 }}
            format={DateFormat}
            placeholder="Дата создания"
            disabled={true}
          />
        )}
      </div>

      <div
        className="offer-card__item"
        style={{ display: "flex", alignItems: "center" }}
      >
        <span className="label">Тариф:</span>
        <Form.Item>
          {getFieldDecorator("tariffType")(
            <Input disabled style={{ width: 224 }} />
          )}
        </Form.Item>
        <Button type={"link"} style={{ width: 128 }} onClick={openTariffInfo}>
          Подробнее о тарифе
        </Button>
      </div>
      <div className="offer-card__item">
        <span className="label">Оплачен до:</span>
        {getFieldDecorator("tariffEndDate")(
          <DatePicker
            style={{ width: 224 }}
            format={DateFormat}
            placeholder="Дата окончания лицензии"
            disabled
          />
        )}
        {getFieldDecorator("tariffEndDate")(
          <TimePicker
            style={{ width: 128, marginLeft: 16 }}
            placeholder="Время окончания лицензии"
            format={TimeFormat}
            disabled
          />
        )}
      </div>
      <Divider />
    </>
  );
};
